import { Component, OnInit } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-ct-seven-one-three',
  templateUrl: './ct-seven-one-three.component.html',
  styleUrls: ['./ct-seven-one-three.component.scss']
})
export class CtSevenOneThreeComponent implements OnInit {
  c241Url='https://gnkc.ac.in/assets/pdf/NAAC/DVV/';
  link:{name:string,src:string}[]=[
    {
      name:'7.1.3_Report on Beyond the Campus Environmental Promotion Activities_1',
      src: '/assets/pdf/NAAC/DVV/7.1.3_Report on Beyond the Campus Environmental Promotion Activities_1.pdf'
    },
    {
      name:'7.1.3_Action Taken Report and Achievement Report on Clean and Green Campus_2',
      src: '/assets/pdf/NAAC/DVV/7.1.3_Action Taken Report and Achievement Report on Clean and Green Campus_2.pdf'
    },
    {
      name:'7.1.3_Environment_Green and Energy Audit report_3',
      src: '/assets/pdf/NAAC/DVV/7.1.3_Environment_Green and Energy Audit report_3.pdf'
    },
    {
      name:'7.1.3_Certificate from the External Auditing Agency_4',
      src: '/assets/pdf/NAAC/DVV/7.1.3_Certificate from the External Auditing Agency_4.pdf'
    },
    {
      name:'7.1.3_Certificates of the Awards from Recognized Agency_5',
      src: '/assets/pdf/NAAC/DVV/7.1.3_Certificates of the Awards from Recognized Agency_5.pdf'
    },
  ];
  selectedValue:{name:string,src:string};
  constructor() { }

  ngOnInit(): void {
    this.changeRoute('1');
  }

  changeRoute(id: string) {
    if (id === '1') {
      $(`one`).addClass('show');
      $(`two`).removeClass('show');
      $(`three`).removeClass('show');
      $(`four`).removeClass('show');
      $(`five`).removeClass('show');
      this.selectedValue=this.link[0];

    }
    if (id === '2') {
      $(`two`).addClass('show');
      $(`one`).removeClass('show');
      $(`three`).removeClass('show');
      $(`four`).removeClass('show');
      $(`five`).removeClass('show');
      this.selectedValue=this.link[1];
    }
    if (id === '3') {
      $(`three`).addClass('show');
      $(`one`).removeClass('show');
      $(`two`).removeClass('show');
      $(`four`).removeClass('show');
      $(`five`).removeClass('show');
      this.selectedValue=this.link[2];
    }
    if (id === '4') {
      $(`four`).addClass('show');
      $(`one`).removeClass('show');
      $(`two`).removeClass('show');
      $(`three`).removeClass('show');
      $(`five`).removeClass('show');
      this.selectedValue=this.link[3];
    }
    if (id === '5') {
      $(`five`).addClass('show');
      $(`one`).removeClass('show');
      $(`two`).removeClass('show');
      $(`three`).removeClass('show');
      $(`four`).removeClass('show');
      this.selectedValue=this.link[4];
    }
  }

}
